import React from 'react';

import { GroupedTasks } from '../../../../widgets/tasks/ui/GroupedTasks';

export const GroupedTasksPage = () => {
  return <GroupedTasks />;
};
